import { FetcherResponse } from '../../lib/fetcher';

export function ensureData<T>(
  response: FetcherResponse<T>,
  context: string,
): T {
  const { data, error } = response;

  if (error) {
    throw new Error(error);
  }

  if (!data) {
    throw new Error(`No data received for ${context}`);
  }

  return data;
}

export function buildSearchParams<T extends object>(obj: T): string {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'expandable') {
      params.set('expandable', String(value));
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, String(v)));
    } else {
      params.append(key, String(value));
    }
  });

  return params.toString();
}
